export enum NavigationPath {
  MY_RFPS = '/myRfps',
  COMMUNITY_RFPS = '/communityrfps',
  RFPS = '/rfps',
  MY_AWARDED_RFPS = '/myAwardedRfps',
  MY_SITE_VISITS = '/mysitevisits',
  MY_PROPOSALS = '/myproposals',
  MY_CONTACTS = '/mycontacts',
  DASHBOARD = '/my/profile/dashboard',
  RESOURCES = '/resources',
  HELP_ARTICLES = '/help-articles',
  CONTRACTOR_SEARCH = '/contractor-search',
  ANALYTICS = '/accounting/analytics',
  INVOICES = '/accounting/invoices',
  SUBSCRIPTIONS = '/bidmii-pro/plans',
  PRO_SETUP = '/bidmii-pro/setup',
  HOW_IT_WORKS = '/m/how-it-works',
  PRICING = '/m/pricing',
  FAQ = '/FAQ',
  ABOUT = '/m/about',
  PARTNERS = '/m/partners',
  CAREERS = '/m/careers',
  SAFETY = '/m/safety-at-bidmii',
  BLOG = '/m/blog',
  DESIGNMII = '/m/designmii',
  TERMS = '/m/terms',
  PRIVACY = '/m/privacy-policy',
  CONTACT = '/m/contact-us',
  FEEDBACK = '/m/feedback', // TODO: no such page in the app
  BIDMII_PRO = '/bidmii-pro',
  CDAP = '/cdap-grant',
  HOME = '/home',
  DEFAULT = '',
}

export const getSelectedIndexFromCurrentUrl = () => {
  if (
    Object.values(NavigationPath).some(
      (path: string) => path === window.location.pathname,
    )
  ) {
    return <NavigationPath>window.location.pathname;
  }

  return NavigationPath.DEFAULT;
};

export const getMyProfilePathFromUserId = (userId: string) => {
  return userId ? `/user/${userId}` : '/my/profile/dashboard';
};
